export default {
  user: {
    userType: "用户类型",
    userInfo: "用户详情",
    levelInfoCell: "等级和直属用户",
    accountInfoCell: "账户信息（近90天）",
    statusInfo: "状态",
    dateInfo: "日期信息",
    remark: "备注",
    option: "操作",
    id: "用户ID",
    account: "用户账号",
    realName: "真实姓名",
    nickName: "用户昵称",
    email: "邮箱",
    phone: "手机号码",
    inviteName: "邀请账号",
    inviteCode: "邀请码",
    proxyName: "上级邀请",
    platformName: "平台",
    proxyId: "所属上级",
    userTierName: "用户组别",
    userNum: "直属下级数",
    balance: "可用额度",
    onlineStatus: "在线状态",
    onlineStatus0: "离线",
    onlineStatus1: "在线",
    createTime: "注册时间",
    loginTime: "最后登录时间",
    loginIp: "登录IP",
    registerIp: "注册IP",
    leaveDayNum: "离开天数",
    leaveDayNum3: "3天以上",
    leaveDayNum7: "7天以上",
    leaveDayNum15: "15天以上",
    platformCode: "所属平台",
    dayClosingOrderCount: "结算订单数",
    earningsClosingAmount: "待结算金额",
    dayValidAmount: "实际投注金额",
    dayResult: "盈亏金额",
    allBetAmount: "投注金额",
    allEarningsAmount: "盈亏金额",
    directlyUnderEarningsAmount: "直属下级总盈亏",
    today: "今天",
    nearly90: "近90天",
    baseInfoTitle: "基本信息",
    directUserTitle: "直属用户",
    directlyUnderMemberCount: "直属用户数",
    underMemberCount: "成员用户数",
    walletAccountTitle: "钱包账户",
    thirdBalance: "第三方金额",
    rebateBackAmount: "返水金额",
    bettingInfoTitle: "投注信息",
    bettingInfoSubtitle: "(近90天信息)",
    earningsClosingCount: "待结算笔数",
    allBetCount: "累积投注笔数",
    drawBackLog: "返水记录",
    amountLog: "账变记录",
    userOrder: "投注记录",
    lowerUserOrder: "下级投注记录",
    lowerUser: "下级用户",
    bonusSetting: "返点信息",
    userOptionLog: "操作日志",
  },
  drawBackLog: {
    amount: "投注金额",
    status: "状态",
    accountInfo: "上级账号",
    userBackName: "直属上级",
    proxyGrade: "级",
    bonus: "奖金",
    rebateInfo: "返点",
    rebateAmountInfo: "返水金额",
    rebate: "退水比例",
    rebateAmount: "退水金额",
    betTime: "投注时间",
    option: "操作",
    detail: "订单详情",
    orderId: "订单号",
    createTime: "创建时间",
    rebateMoney: "返水总金额"
  },
  amountLog: {
    createTime: "时间",
    type: "订单类型",
    amount: "交易金额",
    minAmount: "最小交易金额",
    maxAmount: "最大交易金额",
    amountMsg: "最小交易金额不允许大于最大交易金额",
    otherId: "关联订单号",
    remark: "备注",
    option: "操作",
    detail: "详情",
    orderDetail: "订单详情",
    title: "标题",
    updateTime: "操作时间",
    noOrder: "无关联订单号",
    beforeBalance: "交易前金额",
    afterBalance: "交易后金额",
    event: "事件",
    eventId: "事件编号",
    transferId: "传输ID",
    transferInfo: "传输详情",
    remark1: '注：只保留最新72小时账变记录',
    remark2: '注：超过3分钟的账变记录',
    syncTitle: "同步账变",
  },
  bonusSet: {
    name: "游戏",
    point: "返点",
    status: "返佣返水状态",
    game: "电子游戏",
  },
  blacklist: {
    title: "黑名单",
    cancel: "取消黑名单",
    platformCode: "所属平台",
    userId: "用户账号",
    remark: "备注",
    messageRemark: "请输入备注",
    messageRemove: "是否将选择的用户移出黑名单"
  },

  userGroup: {
    name: "用户组",
    singleMaxRechargeAmount: "每笔在线最高充值金额",
    todayMaxRechargeAmount: "每笔在线最高充值金额",
    singleMaxWithdrawAmount: "每笔最高提现金额",
    todayMaxWithdrawAmount: "当日最高提现金额",
    todayMaxWithdrawCount: "当日最大提款笔数",
    todayMaxNotPayCount: "当日最大未支付笔数",
    sort: "排序",
    option: "操作",
    isDefault: "默认",
    transfer: "转移",
    transferTo: "转移至",
    messageDefault: "确定设为默认?",
    tip1: "请输入1-15个字符",
    tip2: "请输入1-18位纯数字",
    tip3: "请输入1-3位纯数字",
    tip4: "请输入排序",
    setDefault: "设为默认",
  },
  userPortrait: {
    name: "名称",
    link: "图片",
    createTime: "创建时间",
    updateUserName: "操作人",
    option: "操作",
    tip1: "请输入1-100个字符",
    tip2: "请上传图片",
    sort: "排序",
  },
  userLogs: {
    createTime: "操作时间",
    type: "操作类型",
    platformCode: "所属平台",
    ip: "IP地址",
    ipAddress: "IP信息",
    content: "操作内容",
    requestUri: "请求URL",
    params: "操作提交的数据",
    lastParams: "操作提交前的旧数据",
    option: "操作",
    info: "详情"
  },
  userOnline: {
    account: "用户账号",
    platformName: "所属平台",
    gameName: "所在游戏",
    loginTime: "最后登录时间",
    loginIp: "登录IP",
    ipAddress: "IP信息",
    userDetail: "用户详情",
    offline: "踢下线",
    proposeRoom: "踢出房间",
    gameCode: "游戏",
    messageUserOffline: "确定踢下线"
  },
  userForbidden: {
    message1: "确定要取消禁言吗?",
    message2: '请选择要取消禁言的选项',
    message3: '禁言成功',
  }
}
